<template>
  <student-bookings notification/>
</template>

<script>
import StudentBookings from '@/components/student/StudentBookings'

export default {
  components: { StudentBookings }
}
</script>
